<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.School_Join_Us')"></pageTitle>
        <myTableFilter
          @submit="handleSubmit"
          :show="{
                    jobType: true,
                    jobStatus: true,
                    statusText: statusText,
                    typeText:typeText
                }"
        />
        <myTable ref="tables" :columns="columns" requestUrl="job/list" :showPage="true">
          <template v-slot:status="{ data }">
            <div class="df_center">
              <div :class="data.row.status == 1 ? 'blue' : 'grey'">{{ data.row.status_cdesc }}</div>
            </div>
          </template>
          <template v-slot:off_shelf="{ data }">
            <Poptip
              v-if="data.row.status == 1"
              placement="left"
              confirm
              :title="$t('confirm_off_shelf')"
              @on-ok="handleOffShelf(data.row)"
            >
              <a>{{ $t("off_shelf") }}</a>
            </Poptip>
            <span class="no_revert cursor_p" v-else>{{$t("off_shelf")}}</span>
          </template>
          <template v-slot:detail="{ data }">
            <!-- <a @click="handleToDetail(data.row)">{{$t("info")}}</a> -->
            <Icon
              class="cursor_p"
              @click="handleToDetail(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            />
          </template>
        </myTable>
      </div>
    </div>
  </div>
</template>

<script>
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";

export default {
  name: "job",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      statusText: {},
      typeText: {},
      columns: [
        {
          title: this.$t("job.id"),
          key: "job_id",
          align: "center"
        },
        {
          title: this.$t("cms_email.addTime"),
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("job.type"),
          key: "type_cdesc",
          align: "center"
        },
        {
          title: this.$t("job.name"),
          key: "job_cname",
          align: "center"
        },
        {
          title: this.$t("release_status"),
          slot: "status",
          align: "center"
        },
        {
          title: this.$t("publisher"),
          key: "school_cname",
          align: "center"
        },
        {
          title: this.$t("last_update_time"),
          key: "upd_time",
          align: "center"
        },
        {
          title: this.$t("off_shelf"),
          align: "center",
          slot: "off_shelf"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "detail"
        }
      ],

      search: { page: 1, limit: 10 },
      list: [],
      total: 0
    };
  },
  created () {
    this.getBeforeList();
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading;
      this.$request.sendPost(
        "job/before-list",
        {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.statusText = data.status
          this.typeText = data.types
        }
      );
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },

    handleToDetail (item) {
      this.$base.linkTo("/school/recruit_detail", { id: item.job_id });
    },
    handleOffShelf (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        "job/upd-status",
        { job_id: item.job_id, status: 0 },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          //添加ref 运行子组件方法
          this.$refs.tables.getLoad();
        }
      );

    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .blue {
    background-color: var(--blue_one);
    color: #fff;
    border-radius: 20px;
    width: 100px;
    padding: 3px 0;
  }
  .green {
    background-color: var(--green_four);
    color: #fff;
    border-radius: 20px;
    width: 100px;
    padding: 3px 0;
  }
  .grey {
    background-color: #ccc;
    color: #fff;
    border-radius: 20px;
    width: 100px;
    padding: 3px 0;
  }
  .no_revert {
    color: #a6a6a7;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/job/job.vue